import { render, staticRenderFns } from "./prviewPaper.vue?vue&type=template&id=ac9f2568&scoped=true&"
import script from "./prviewPaper.vue?vue&type=script&lang=js&"
export * from "./prviewPaper.vue?vue&type=script&lang=js&"
import style0 from "./prviewPaper.vue?vue&type=style&index=0&id=ac9f2568&lang=scss&scoped=true&"
import style1 from "./prviewPaper.vue?vue&type=style&index=1&id=ac9f2568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9f2568",
  null
  
)

export default component.exports